import { useTheme } from '@mui/material/styles';

const useMaterialIcons = () => {
  const { palette } = useTheme();

  const materialIcons = {
    // Required to load FILL@1 variant
    '@font-face': {
      fontFamily: 'Material Symbols Outlined',
      fontStyle: 'normal',
      fontWeight: 400
      //! next line will break some icons like "passkey"
      // src: "url(https://fonts.gstatic.com/s/materialsymbolsoutlined/v122/kJEPBvYX7BgnkSrUwT8OhrdQw4oELdPIeeII9v6oDMzBwG-RpA6RzaxHMPdY40KH8nGzv3fzfVJO1Q.woff2) format('woff2')"
    },

    // Define default font settings
    '.material-symbols-outlined': {
      display: 'inline-block',
      fontDisplay: 'block', // https://www.w3.org/TR/css-fonts-4/#font-display-desc
      fontFamily: "'Material Symbols Outlined'",
      fontWeight: 400,
      fontStyle: 'normal',
      fontSize: '1.5rem',
      lineHeight: 1,
      letterSpacing: 'normal',
      textTransform: 'none',
      whiteSpace: 'nowrap',
      wordWrap: 'normal',
      direction: 'ltr',
      WebkitFontFeatureSettings: "'liga'",
      WebkitFontSmoothing: 'antialiased',
      color: palette.primary.dark,
      opacity: 0, // hide icons while loading
      transition: 'opacity 500ms'
    },

    // Global class for icons loading
    '.material-symbols-outlined.loaded': {
      opacity: 1 // show icons when loaded
    },

    // Global class for filled icons
    '.material-symbols-outlined.filled': {
      fontVariationSettings: "'FILL' 1"
    }
  };

  return { materialIcons };
};

export default useMaterialIcons;
